import { ActionListItemModel } from "@genexus/chameleon-controls-library";
import { KBData } from "./create-kb-from-server";

export const mapKbsModelToActionListModel = (
  kbsData: KBData[]
): ActionListItemModel[] => {
  const listBoxItems: ActionListItemModel[] = [];
  kbsData.forEach(kb => {
    listBoxItems.push({
      id: kb.id,
      type: "actionable",
      caption: kb.name
    });
  });
  return listBoxItems;
};
